<template>
    <div class="greybox">
        <h1>{{repairOptionTitle}}</h1>
        <div v-html="repairOptionDetails" />
        <div class="button-fluid-container">
          <button @click="handleCloseClick()" class="button" v-if="repairOptionCount > 1">Back to Repair options</button>
          <button @click="handleBackToClaim()" class="button">Back to claim</button>
          <button class="button" @click="handleContinueClick()">Continue</button>
        </div>
        <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>       
    </div>
</template>
<script>
import loading from 'vue-loading-overlay'
import { mapActions } from 'vuex'
import repairOptionsBase from '@/mixins/repairOptionsBase'

export default {
  components: {
    loading
  },
  mixins: [
    repairOptionsBase
  ],
  data: () => {
    return {

    }
  },
  computed: {
    showCardDetails () {
      if (this.selectedRepairOption.repairOptionWebDisplayRequireCardDetails) {
        if (this.isStandalone == true) {
          console.log('Standalone')
          if (!this.selectedGadget.excessCardPayment) {
            return true
          } else {
            if (this.selectedGadget.excessCardPayment.statusId != 1022) {
              return true
            } 
          }  
        } else {
          console.log('Tiga')
          console.log(this.selectedClaim.excessCardPayment)
          if (!this.selectedClaim.excessCardPayment) {
            return true
          } else {
            if (this.selectedClaim.excessCardPayment.statusId != 1022) {
              return true
            } 
          }
        } 
      }
      return false      
    },
    repairOptionCount () {
      if(this.$store.state.repairoptions.repairOptionsList) {
        return this.$store.state.repairoptions.repairOptionsList.length
      } else {
        return 0
      }      
    },
    showBankDetails () {
      if (this.selectedRepairOption.requireBankDetails && this.isBankDetailsEmpty) {
        return true
      }

      return false
    },
    isBankDetailsEmpty () {
            let { bankDetails } = this.$store.state.myclaims.selectedClaim
            if (bankDetails) {
                return bankDetails.name == '' || bankDetails.name == null
            }
            return true
        }
  },
  beforeMount () {

  },
  methods: {
    handleCloseClick () {
      //this.$router.go(-1)
      this.$router.push({path: '/myclaims/repairoptions/list'})
    },
    handleBackToClaim () {
      this.$router.push({ path: '/myclaims/view/' + this.selectedClaim.id })
    },
    handleContinueClick () {
      if (this.selectedRepairOption.requireBooking) {
        this.$router.push({ path: '/myclaims/repairoptions/booking/' })
      } else {
        if(this.showCardDetails || this.showBankDetails) {
          this.$router.push({ path: '/myclaims/repairoptions/continue/' })
        } else {
          this.setRepairOption(this.selectedGadgetId)
        }        
      }
    }
  }
}
</script>
